<!-- 柱状图 -->
<style lang="stylus" scoped>
.bar-wrap {
  width: 100%;
  height: 284px;
  padding: 18px 0;
}

.instruction {
  display: flex;
  justify-content: space-between;

  .item-name {
    margin-bottom: 5px;
    color: #77CAD8;
    font-size: 14px;
  }

  .item-num {
    color: #fff;
    font-size: 20px;
    font-weight: 400;
    text-align: center;
  }
}

.bars {
  height: 250px;

  .main {
    margin-left: 30px;
    width: 100%;
    height: 100%;
  }
}
</style>

<template>
  <boxWrap :name="name">
    <div class="bar-wrap">
      <div class="bars">
        <div class="main"></div>
      </div>
    </div>
  </boxWrap>
</template>

<script>
import echarts from 'echarts'
import boxWrap from '../common/boxWrap';
export default {
  props: ["regionBar"],
  data() {
    return {
      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
      myChart: {},
      name: '脱贫家庭数',
      dataX: [],
      dataY: []
    }
  },
  components: {
    boxWrap
  },
  methods: {
    init() {
      window.addEventListener('resize', function () {
        this.myChart.resize()
      }.bind(this))
    }
  },
  mounted() {
    // console.log(this.regionBar)
    var count = 0;
    for (var i = 0; i < this.regionBar.length; i++) {
      if (this.regionBar[i].name && count < 5) {
        this.dataX.push(this.regionBar[i].name)
        this.dataY.push(this.regionBar[i].number)
        count++
      }
    }
    // 基于准备好的dom，初始化echarts实例
    this.myChart = echarts.init(document.querySelector('.bars .main'));
    this.myChart.setOption({
      xAxis: {
        data: this.dataX,
        axisLine: {
          lineStyle: {
            color: '#0177d4'
          }
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          interval: 0,
          color: '#77CAD8',
          fontSize: 12
        }
      },
      yAxis: {
        nameTextStyle: {
          color: ' #77CAD8',
          fontSize: 12
        },
        axisLine: {
          lineStyle: {
            color: '#0177d4'
          }
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          color: '#77CAD8',
          fontSize: 12
        },
        splitLine: {
          show: false,
          lineStyle: {
            color: '#0177d4'
          }
        }
      },
      grid: {
        left: '12%'
      },
      series: [{
        type: 'bar',
        barWidth: 18,
        itemStyle: {
          normal: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: '#C0E450'
            }, {
              offset: 0.8,
              color: '#75CD2D'
            }], false)
          }
        },
        data: this.dataY
      }]
    })
    this.init();
  }
}

</script>



// WEBPACK FOOTER //
// index.vue?edd2f16e